var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFAAFF",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm-3-8a2 2 0 1 0-4 0 1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v6.063A2 2 0 0 0 11.5 16H9zm6.5 0a2 2 0 0 0-1.5-1.937V9.5a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3V15a1 1 0 0 1-1 1h-3.5zm0-4.008l2.995.008.005-.577c0-.865-.5-1.34-1.5-1.423h-1c-.305 0-.472.164-.5.49v1.502zM7 17.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm6.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckInCircle);
export default __webpack_public_path__ + "static/media/truck-in-circle.4e65934b4e829f72cfd7affc87392d26.svg";
export { ForwardRef as ReactComponent };